import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import type { MenuPermission } from '@/types/sidebar-menu.types'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * 메뉴 권한 체크 함수
 * Check if user has permission for a menu
 * 
 * @param menuKey - 메뉴 키 (없거나 0 이하면 항상 허용)
 * @param permissions - 권한 목록
 * @returns 권한 있으면 true, 없으면 false
 * 
 * @example
 * ```ts
 * const hasPermission = hasMenuPermission(1, [
 *   { menuKey: 1, permissionLevel: 2 },
 *   { menuKey: 2, permissionLevel: 1 }
 * ])
 * ```
 */
export function hasMenuPermission(
  menuKey: number | undefined,
  permissions: MenuPermission[] | undefined
): boolean {
  // menuKey가 없거나 0 이하면 항상 허용 (기본 메뉴)
  if (!menuKey || menuKey <= 0) {
    return true
  }

  // 권한 목록이 없으면 모두 허용
  if (!permissions || permissions.length === 0) {
    return true
  }

  // 권한 목록에서 해당 menuKey 찾기
  // permissionLevel > 0 이면 권한 있는 것으로 판단
  return permissions.some(
    (p) => p.menuKey === menuKey && p.permissionLevel > 0
  )
}


